import Vue from "vue";

import { sortByOrderInPlace } from "@/common/utils.sort";
import { removeElementFromArray } from "@/common/utils.array";
import utilsOrder from "@/common/utils.order";

import eventAction from "@/store/eventAction";

const vue = new Vue();

import cache from "@/store/cache";
import urlManager from "@/common/urls";

function defaultState() {
  return {
    all: [],
    archived: [],
    active: null,
    activateNewBoard: false
  };
}
// state
const state = defaultState();

// getters
const getters = {};

// actions
const actions = {
  clear({ state }) {
    Object.assign(state, defaultState());
  },
  socket_boards({ state, commit, rootState }, data) {
    if (data.boards) {
      for (var i = 0; i < data.boards.length; i++) {
        commit("ADD", data.boards[i]);
      }
    }

    const user = rootState.users.active;

    if (user && user.active_board) {
      commit("SET_ACTIVE", cache.boards.byId(user.active_board));
    }
    if (!state.active) {
      commit("SET_ACTIVE", data.boards[0]);
    }
  },

  socket_archivedCards({ commit }, data) {
    if (!data) return;

    if (data.cards) {
      commit(
        "cards/ADD_RANGE",
        data.cards.map(card => {
          return {
            board: cache.boards.byId(card.board_id),
            list: cache.lists.byId(card.list_id),
            card: card
          };
        }),
        { root: true }
      );
    }

    if (data.events) {
      commit(
        "events/ADD_RANGE",
        data.events.map(event => {
          return {
            card: cache.cards.byId(event.card_id),
            event: event
          };
        }),
        { root: true }
      );
    }

    if (data.card_fields_int) {
      commit(
        "fieldsInt/ADD_RANGE_CARD",
        data.card_fields_int.map(field => {
          return {
            boardField: cache.boardFieldsInt.byId(field.board_field_id),
            card: cache.cards.byId(field.card_id),
            field: field
          };
        }),
        { root: true }
      );
    }

    if (data.card_fields_txt) {
      commit(
        "fieldsTxt/ADD_RANGE_CARD",
        data.card_fields_txt.map(field => {
          return {
            boardField: cache.boardFieldsTxt.byId(field.board_field_id),
            card: cache.cards.byId(field.card_id),
            field: field
          };
        }),
        { root: true }
      );
    }
  },
  async activateBoard({ commit, dispatch, rootState }, board) {
    if (!board) return;

    if (!board.id) {
      board = await cache.boards.byIdAsync(board);
    }

    if (!board) {
      console.error("can't activate null board");
      return;
    }
    const user = rootState.users.active;
    if (user && board.id == user.active_board) {
      return;
    }
    user.active_board = board.id;
    commit("users/SET", user, { root: true });

    commit("SET_ACTIVE", board);
    await dispatch(
      "events/emit",
      {
        action: eventAction.user.activeBoard.change,
        param1: board.id
      },
      { root: true }
    );

    await dispatch("moveToTop", board);
  },

  new({ state, dispatch }, { title }) {
    state.activateNewBoard = true;
    dispatch(
      "events/emit",
      {
        action: eventAction.board.new,
        data: title
      },
      { root: true }
    );
  },

  editTitle({ dispatch }, { board, title }) {
    board.title = title;
    dispatch(
      "events/emit",
      {
        action: eventAction.board.title.edit,
        board: board,
        data: title
      },
      { root: true }
    );
  },

  getArchivedCards({ rootState }, board) {
    let boardId = board;
    if (boardId.id) {
      boardId = boardId.id;
    } else {
      board = cache.boards.byId(boardId);
    }
    if (board.isArchiveLoaded) {
      return;
    }
    vue.$socket.emit("archived_cards", {
      user_id: rootState.users.active.id,
      board_id: boardId
    });
  },

  moveToTop({ dispatch, state }, board) {
    const index = state.all.findIndex(b => b.id == board.id);
    if (index < 1) return;
    const firstBoard = state.all[0];
    const newOrder = utilsOrder.prev(firstBoard.order);

    dispatch(
      "events/emit",
      {
        action: eventAction.board.move,
        board: board,
        data: newOrder
      },
      { root: true }
    );
  },

  move({ dispatch }, { board, order }) {
    dispatch(
      "events/emit",
      {
        action: eventAction.board.move,
        board: board,
        data: order
      },
      { root: true }
    );
  },

  addUser({ dispatch }, { board, user }) {
    dispatch(
      "events/emit",
      {
        action: eventAction.board.user.add,
        board: board,
        param1: user.id
      },
      { root: true }
    );
    //  commit("users/ADD_REL", { board: board, user: user }, { root: true });
  },

  deleteUser({ dispatch }, { board, user }) {
    dispatch(
      "events/emit",
      {
        action: eventAction.board.user.delete,
        board: board,
        param1: user.id
      },
      { root: true }
    );
    // commit("users/DELETE_REL", { board: board, user: user }, { root: true });
  },

  archive({ dispatch }, board) {
    if (state.active == board) {
      const notActiveBoard = state.all.find(b => b != board);
      dispatch("activateBoard", notActiveBoard);
    }

    dispatch(
      "events/emit",
      {
        action: eventAction.board.archive,
        board: board
      },
      { root: true }
    );
  },

  dearchive({ dispatch }, board) {
    dispatch(
      "events/emit",
      {
        action: eventAction.board.dearchive,
        board: board
      },
      { root: true }
    );
  },

  handleEvent({ state, rootState, commit, dispatch }, event) {
    const requirements = eventAction.requireFor(rootState, event);
    if (!requirements) return;

    const board = requirements.board;

    switch (event.action) {
      case eventAction.board.new: {
        const newBoard = {
          id: event.board_id,
          title: event.data,
          user_id: event.user_id,
          date: event.date
        };

        commit("ADD", newBoard);
        if (state.activateNewBoard) {
          state.activateNewBoard = false;
          dispatch("activateBoard", newBoard);
        }
        break;
      }
      case eventAction.board.title.edit: {
        board.title = event.data;
        break;
      }
      case eventAction.board.move: {
        if (event.data) {
          board.order = event.data;
          board.hasBoardOrder = true;
          sortByOrderInPlace(state.all);
        } else {
          console.error("moveBoard must has data!");
        }
        break;
      }
      case eventAction.board.user.add: {
        commit("users/ADD_REL", { board: board, user: cache.users.byId(event.param1) }, { root: true });
        break;
      }
      case eventAction.board.user.delete: {
        commit("users/DELETE_REL", { board: board, user: cache.users.byId(event.param1) }, { root: true });
        break;
      }
      case eventAction.user.activeBoard.change: {
        //ignore it
        break;
      }
      case eventAction.board.archive: {
        commit("ARCHIVE", {
          board: board,
          status: true
        });
        break;
      }
      case eventAction.board.dearchive: {
        commit("ARCHIVE", {
          board: board,
          status: false
        });
        break;
      }
    }
  }
};

// mutations
const mutations = {
  SET_ACTIVE(state, board) {
    if (!board) return;

    state.active = board;
    urlManager.toBoardIdNeeded(board);
  },
  ADD(state, board) {
    if (!board) return;

    if (!board.id) {
      console.error("Cant add board without id", board);
      return;
    }

    if (!cache.boards.tryAdd(board)) {
      return;
    }

    if (!board.order) {
      let prevBoard = state.all[state.all.length - 1];
      if (prevBoard) {
        board.order = utilsOrder.next(prevBoard.order);
      } else {
        board.order = utilsOrder.default();
      }
    } else {
      board.hasBoardOrder = true;
    }

    if (board.archived) {
      state.archived.push(board);
    } else {
      state.all.push(board);
      sortByOrderInPlace(state.all);
    }
  },
  ADD_ORDER(state, boardOrder) {
    if (!boardOrder) return;

    if (!boardOrder.id) {
      console.error("Cant add boardOrder without id", boardOrder);
      return;
    }

    const board = cache.boards.byId(boardOrder.board_id);
    if (!board) {
      console.error("board is not existing for boardOrder", boardOrder);
      return;
    }

    board.order = boardOrder.order;
    board.hasBoardOrder = true;

    sortByOrderInPlace(state.all);
  },
  ARCHIVE(state, { board, status }) {
    if (!board) return;

    if (!board.id) {
      console.error("Cant archive board without id", board);
      return;
    }

    board.archived = status;
    if (status) {
      removeElementFromArray(state.all, board);
    } else {
      console.error("dearchive of board not supported yet");
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
